import { Link } from 'react-router-dom';

import { ROUTES } from '../../constants';
import { getDashboardHref, getSignInHref } from '../../utils/getSignInHref';
import { StratEduLogo } from '../brand/StratEduLogo';
import { Button } from '../common/Button';

type MarketingSiteHeaderProps = {
  isAuthenticated: boolean;
};

export function MarketingSiteHeader({
  isAuthenticated,
}: MarketingSiteHeaderProps) {
  const signInHref = isAuthenticated ? getDashboardHref() : getSignInHref();
  const signInLabel = isAuthenticated ? 'Dashboard' : 'Sign in';
  const signInIsExternal = signInHref.startsWith('http');

  return (
    <header className="border-b border-[var(--se-midnight-muted)] bg-strat-midnight">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:gap-4 sm:px-6">
        <StratEduLogo layout="lockup" appearance="dark" linkToHome />
        <nav className="flex items-center gap-2 sm:gap-3">
          <Link
            to={ROUTES.CONTACT}
            className="hidden text-sm font-medium text-white/80 hover:text-white sm:inline"
          >
            Contact
          </Link>
          {signInIsExternal ? (
            <a href={signInHref}>
              <Button size="sm" variant="secondary">
                {signInLabel}
              </Button>
            </a>
          ) : (
            <Link to={isAuthenticated ? ROUTES.DASHBOARD : ROUTES.LOGIN}>
              <Button size="sm" variant="secondary">
                {signInLabel}
              </Button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
